import { Stack as Stack$1, StackItem } from './Stack.js';

const Stack = Object.assign(Stack$1, {
  Item: StackItem
});

export { Stack };
